// extracted by mini-css-extract-plugin
export default {"registerPage":"register_registerPage__2cZdv"};